// extracted by mini-css-extract-plugin
module.exports = {"button":"PageTitleImageButton_button__3MXeo"};